var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgVisible = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9939 5.00002C16.3881 4.95486 20.3582 7.61648 21.9878 11.7C22.004 11.7994 22.004 11.9007 21.9878 12C21.9911 12.113 21.9706 12.2254 21.9279 12.33C20.2967 16.3812 16.3588 19.0253 11.9939 19C7.62404 19.022 3.68477 16.3691 2.05996 12.31C2.01984 12.2116 1.99947 12.1063 1.99999 12C2.00127 11.8874 2.02155 11.7759 2.05996 11.67C3.69112 7.61878 7.62898 4.97477 11.9939 5.00002ZM8.99573 12C8.99573 13.6569 10.3381 15 11.9939 15C12.7891 15 13.5517 14.6839 14.1139 14.1213C14.6762 13.5587 14.9921 12.7957 14.9921 12C14.9921 10.3432 13.6498 9.00002 11.9939 9.00002C10.3381 9.00002 8.99573 10.3432 8.99573 12Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVisible, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/visible.2c981e73.svg";
export { ForwardRef as ReactComponent };